import { jsx as t, jsxs as I, Fragment as W } from "react/jsx-runtime";
import { AlertGroup as en, Alert as tn, AlertVariant as Ne, AlertActionCloseButton as nn, Page as rn, Modal as vt, ModalVariant as an, TextContent as ln, Text as Ce, Button as _, Spinner as bt, FormHelperText as We, HelperText as ze, HelperTextItem as Je, Popover as sn, Icon as _e, FormGroup as Ct, NumberInput as on, ValidatedOptions as H, InputGroup as Se, InputGroupItem as qe, TextInput as Te, Select as xe, SelectList as Ee, SelectOption as Ye, MenuToggle as pe, MenuToggleStatus as Qe, TextInputGroup as kt, TextInputGroupMain as It, ChipGroup as Xe, Chip as Ze, TextInputGroupUtilities as wt, Switch as cn, TextArea as St, FileUpload as dn, Title as un, Card as hn, CardHeader as fn, CardTitle as pn, CardBody as mn, Grid as gn, GridItem as st, PageSection as yn, JumpLinks as vn, JumpLinksItem as bn, ButtonVariant as Ie, Checkbox as Cn, Radio as kn, MenuFooter as In, Dropdown as wn, DropdownList as Sn, DropdownItem as ot, Masthead as Tn, MastheadToggle as xn, PageToggleButton as En, MastheadBrand as An, MastheadContent as Rn, Toolbar as ke, ToolbarContent as Ue, ToolbarItem as G, Avatar as Dn, Bullseye as On, EmptyState as Fn, EmptyStateIcon as ct, EmptyStateHeader as Pn, EmptyStateBody as Ln, EmptyStateFooter as Vn, EmptyStateActions as Mn, SearchInput as Bn, Divider as Nn, Pagination as _n, Badge as qn } from "@patternfly/react-core";
import { createContext as Tt, useContext as xt, useRef as Y, useEffect as le, useCallback as he, useState as R, useMemo as U, isValidElement as Et, forwardRef as Un, useId as At, Fragment as Rt, Children as Dt, Component as $n } from "react";
import { useTranslation as q } from "react-i18next";
import { NetworkError as Ot } from "@keycloak/keycloak-admin-client";
import Kn from "keycloak-js";
import { ExclamationCircleIcon as Hn, ExclamationTriangleIcon as jn, HelpIcon as Gn, EyeIcon as Wn, EyeSlashIcon as zn, TimesIcon as Ft, CubeIcon as Jn, PaypalIcon as Yn, InstagramIcon as Qn, BitbucketIcon as Xn, MicrosoftIcon as Zn, TwitterIcon as er, StackOverflowIcon as tr, OpenshiftIcon as nr, LinkedinIcon as rr, GoogleIcon as ar, GitlabIcon as lr, FacebookSquareIcon as ir, GithubIcon as sr, MinusCircleIcon as or, PlusCircleIcon as Pt, EllipsisVIcon as cr, BarsIcon as dr, SearchIcon as ur, SyncAltIcon as hr } from "@patternfly/react-icons";
import { useFormContext as Ae, Controller as oe, useController as Re, FormProvider as fr, useWatch as pr } from "react-hook-form";
import { get as N, intersectionBy as mr, cloneDeep as gr } from "lodash-es";
import ve from "@patternfly/react-styles/css/components/Avatar/avatar";
import { css as yr } from "@patternfly/react-styles";
import { Table as vr, TableVariant as br, Thead as Cr, Tr as be, Th as Ve, Tbody as dt, Td as ie, ExpandableRowContent as kr, ActionsColumn as Ir, TableText as wr } from "@patternfly/react-table";
import './main.css';function et(e, n) {
  const r = Tt(n);
  return r.displayName = e, r;
}
const Sr = ["error", "errorMessage"], Me = "error_description";
function Tr(e) {
  if (typeof e == "string")
    return e;
  if (e instanceof Ot)
    return Lt(e.responseData);
  if (e instanceof Error)
    return e.message;
  throw new Error("Unable to determine error message.");
}
function xr(e) {
  if (!(e instanceof Ot))
    return;
  const n = e.responseData;
  return Er(n);
}
function Er(e) {
  if (typeof e == "object" && e !== null && Me in e && typeof e[Me] == "string")
    return e[Me];
}
function Lt(e) {
  if (!(typeof e != "object" || e === null))
    for (const n of Sr) {
      const r = e[n];
      if (typeof r == "string")
        return r;
    }
}
const Ar = () => Math.floor(Math.random() * 1e3);
function Rr(e) {
  return e != null;
}
function tt(e) {
  const n = xt(e);
  if (Rr(n))
    return n;
  throw new Error(
    `No provider found for ${e.displayName ? `the '${e.displayName}'` : "an unknown"} context, make sure it is included in your component hierarchy.`
  );
}
function Dr() {
  const e = Y(!1), n = Y(/* @__PURE__ */ new Set());
  le(() => (e.current = !1, () => {
    e.current = !0, r();
  }), []);
  function r() {
    n.current.forEach((a) => clearTimeout(a)), n.current.clear();
  }
  return he((a, l) => {
    if (e.current)
      throw new Error("Can't schedule a timeout on an unmounted component.");
    const i = Number(setTimeout(s, l));
    n.current.add(i);
    function s() {
      n.current.delete(i), a();
    }
    return function() {
      clearTimeout(i), n.current.delete(i);
    };
  }, []);
}
function Or({ alerts: e, onCloseAlert: n }) {
  return /* @__PURE__ */ t(
    en,
    {
      "data-testid": "global-alerts",
      isToast: !0,
      style: { whiteSpace: "pre-wrap" },
      children: e.map(({ id: r, variant: a, message: l, description: i }, s) => /* @__PURE__ */ t(
        tn,
        {
          "data-testid": s === 0 ? "last-alert" : void 0,
          isLiveRegion: !0,
          variant: Ne[a],
          component: "p",
          variantLabel: "",
          title: l,
          actionClose: /* @__PURE__ */ t(
            nn,
            {
              title: l,
              onClose: () => n(r)
            }
          ),
          children: i && /* @__PURE__ */ t("p", { children: i })
        },
        r
      ))
    }
  );
}
const Fr = 8e3, Vt = et(
  "AlertContext",
  void 0
), qa = () => tt(Vt), Pr = ({ children: e }) => {
  const { t: n } = q(), r = Dr(), [a, l] = R([]), i = (c) => l((h) => h.filter((u) => u.id !== c)), s = he(
    (c, h = Ne.success, u) => {
      const m = {
        id: Ar(),
        message: c,
        variant: h,
        description: u
      };
      l((g) => [m, ...g]), r(() => i(m.id), Fr);
    },
    [r]
  ), o = he(
    (c, h) => {
      const u = n(c, { error: Tr(h) }), m = xr(h);
      s(u, Ne.danger, m);
    },
    [s, n]
  ), d = U(() => ({ addAlert: s, addError: o }), [s, o]);
  return /* @__PURE__ */ I(Vt.Provider, { value: d, children: [
    /* @__PURE__ */ t(Or, { alerts: a, onCloseAlert: i }),
    e
  ] });
}, Lr = (e) => {
  const { t: n, i18n: r } = q(), a = e.error, l = Vr(a), i = Lt(a);
  console.error(a);
  function s() {
    location.href = location.origin + location.pathname;
  }
  return /* @__PURE__ */ t(rn, { children: /* @__PURE__ */ t(
    vt,
    {
      variant: an.small,
      title: n("somethingWentWrong"),
      titleIconVariant: "danger",
      showClose: !1,
      isOpen: !0,
      actions: [
        /* @__PURE__ */ t(_, { variant: "primary", onClick: s, children: n("tryAgain") }, "tryAgain")
      ],
      children: /* @__PURE__ */ t(ln, { children: l ? /* @__PURE__ */ t(Ce, { children: n(l) }) : i && r.exists(i) ? /* @__PURE__ */ t(Ce, { children: n(i) }) : /* @__PURE__ */ t(Ce, { children: n("somethingWentWrongDescription") }) })
    }
  ) });
};
function Vr(e) {
  return e instanceof Error ? e.message : null;
}
function Mr(e, n, r) {
  const [a, l] = R(
    () => e.getItem(n) ?? r
  ), i = he((s) => {
    l(s), e.setItem(n, s);
  }, []);
  return le(() => {
    l(e.getItem(n) ?? r), window.addEventListener("storage", s);
    function s(o) {
      o.storageArea === e && (o.key === null || o.key === n) && l(o.newValue ?? r);
    }
    return () => window.removeEventListener("storage", s);
  }, [e, n]), [a, i];
}
function Mt(e, n, r) {
  const a = U(
    () => JSON.stringify(r),
    [r]
  ), [l, i] = Mr(
    e,
    n,
    a
  ), s = U(() => JSON.parse(l), [l]), o = he(
    (d) => i(JSON.stringify(d)),
    []
  );
  return [s, o];
}
const Bt = et(
  "HelpContext",
  void 0
), Br = () => tt(Bt), Nr = ({ children: e }) => {
  const [n, r] = Mt(localStorage, "helpEnabled", !0);
  function a() {
    r(!n);
  }
  return /* @__PURE__ */ t(Bt.Provider, { value: { enabled: n, toggleHelp: a }, children: e });
}, _r = () => Tt(void 0);
let $e;
const Ua = () => {
  const e = xt(
    $e
  );
  if (!e)
    throw Error(
      "no environment provider in the hierarchy make sure to add the provider"
    );
  return e;
}, $a = ({
  environment: e,
  keycloak: n,
  children: r
}) => {
  $e = _r();
  const a = Y(!1), [l, i] = R(!!n), [s, o] = R(), d = U(() => {
    if (n)
      return n;
    const c = new Kn({
      url: e.serverBaseUrl,
      realm: e.realm,
      clientId: e.clientId
    });
    return c.onAuthLogout = () => c.login(), c;
  }, [e, n]);
  return le(() => {
    if (n || a.current)
      return;
    d.init({
      onLoad: "login-required",
      pkceMethod: "S256",
      responseMode: "query",
      scope: e.scope
    }).then(() => i(!0)).catch((h) => o(h)), a.current = !0;
  }, [d, n]), s ? /* @__PURE__ */ t(Lr, { error: s }) : l ? /* @__PURE__ */ t($e.Provider, { value: { environment: e, keycloak: d }, children: /* @__PURE__ */ t(Pr, { children: /* @__PURE__ */ t(Nr, { children: r }) }) }) : /* @__PURE__ */ t(bt, {});
};
function Ka() {
  const n = document.getElementById("environment")?.textContent;
  if (typeof n != "string")
    throw new Error("Environment variables not found in the document.");
  try {
    return JSON.parse(n);
  } catch {
    throw new Error("Unable to parse environment variables as JSON.");
  }
}
const Ha = ({
  modalTitle: e,
  continueLabel: n,
  cancelLabel: r,
  buttonTitle: a,
  isDisabled: l,
  buttonVariant: i,
  buttonTestRole: s,
  onContinue: o,
  component: d = _,
  children: c,
  ...h
}) => {
  const [u, m] = R(!1);
  return /* @__PURE__ */ I(W, { children: [
    /* @__PURE__ */ t(
      d,
      {
        variant: i,
        onClick: () => m(!0),
        isDisabled: l,
        "data-testrole": s,
        children: a
      }
    ),
    /* @__PURE__ */ t(
      vt,
      {
        variant: "small",
        ...h,
        title: e,
        isOpen: u,
        onClose: () => m(!1),
        actions: [
          /* @__PURE__ */ t(
            _,
            {
              id: "modal-confirm",
              variant: "primary",
              onClick: () => {
                m(!1), o();
              },
              children: n
            },
            "confirm"
          ),
          /* @__PURE__ */ t(
            _,
            {
              id: "modal-cancel",
              variant: "secondary",
              onClick: () => m(!1),
              children: r
            },
            "cancel"
          )
        ],
        children: c
      }
    )
  ] });
}, Nt = ({ message: e, ...n }) => /* @__PURE__ */ t(We, { ...n, children: /* @__PURE__ */ t(ze, { children: /* @__PURE__ */ t(Je, { icon: /* @__PURE__ */ t(Hn, {}), variant: "error", children: e }) }) }), _t = ({
  helpText: e,
  fieldLabelId: n,
  noVerticalAlign: r = !0,
  unWrap: a = !1,
  isRecommendation: l = !1
}) => {
  const { enabled: i } = Br(), s = l ? jn : Gn;
  return i ? /* @__PURE__ */ t(sn, { bodyContent: e, children: /* @__PURE__ */ I(W, { children: [
    !a && /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        "data-testid": `help-label-${n}`,
        "aria-label": n,
        onClick: (o) => o.preventDefault(),
        className: "pf-v5-c-form__group-label-help",
        children: /* @__PURE__ */ t(
          _e,
          {
            isInline: r,
            status: l ? "warning" : void 0,
            children: /* @__PURE__ */ t(s, {})
          }
        )
      }
    ),
    a && /* @__PURE__ */ t(
      _e,
      {
        isInline: r,
        status: l ? "warning" : void 0,
        children: /* @__PURE__ */ t(s, {})
      }
    )
  ] }) }) : null;
};
function ce(e) {
  if (!(typeof e > "u" || e instanceof RegExp))
    return typeof e == "object" ? e.value : e;
}
const Q = ({
  id: e,
  name: n,
  label: r,
  labelIcon: a,
  error: l,
  children: i,
  ...s
}) => /* @__PURE__ */ I(
  Ct,
  {
    label: r || n,
    fieldId: e || n,
    labelIcon: Et(a) ? a : a ? /* @__PURE__ */ t(_t, { helpText: a, fieldLabelId: e || n }) : void 0,
    ...s,
    children: [
      i,
      l && /* @__PURE__ */ t(Nt, { "data-testid": `${n}-helper`, message: l.message })
    ]
  }
), ja = ({
  name: e,
  label: n,
  controller: r,
  labelIcon: a,
  ...l
}) => {
  const {
    control: i,
    formState: { errors: s }
  } = Ae();
  return /* @__PURE__ */ t(
    Q,
    {
      name: e,
      label: n,
      isRequired: r.rules?.required === !0,
      error: s[e],
      labelIcon: a,
      children: /* @__PURE__ */ t(
        oe,
        {
          ...r,
          name: e,
          control: i,
          render: ({ field: o }) => {
            const d = !!r.rules?.required, c = ce(r.rules?.min), h = o.value ?? r.defaultValue, u = (m) => o.onChange(
              c !== void 0 ? Math.max(m, Number(c)) : m
            );
            return /* @__PURE__ */ t(
              on,
              {
                ...l,
                id: e,
                value: h,
                validated: s[e] ? H.error : H.default,
                required: d,
                min: Number(c),
                max: Number(r.rules?.max),
                onPlus: () => u(h + 1),
                onMinus: () => u(h - 1),
                onChange: (m) => {
                  const g = Number(m.currentTarget.value);
                  u(isNaN(g) ? r.defaultValue : g);
                }
              }
            );
          }
        }
      )
    }
  );
}, qr = ({
  hasReveal: e = !0,
  innerRef: n,
  ...r
}) => {
  const { t: a } = q(), [l, i] = R(!0);
  return /* @__PURE__ */ I(Se, { children: [
    /* @__PURE__ */ t(qe, { isFill: !0, children: /* @__PURE__ */ t(
      Te,
      {
        ...r,
        type: l ? "password" : "text",
        ref: n
      }
    ) }),
    e && /* @__PURE__ */ t(
      _,
      {
        variant: "control",
        "aria-label": a("showPassword"),
        onClick: () => i(!l),
        children: l ? /* @__PURE__ */ t(Wn, {}) : /* @__PURE__ */ t(zn, {})
      }
    )
  ] });
}, qt = Un(
  (e, n) => /* @__PURE__ */ t(qr, { ...e, innerRef: n })
);
qt.displayName = "PasswordInput";
const Ga = (e) => {
  const { labelIcon: n, ...r } = e, a = !!ce(e.rules?.required), l = e.defaultValue ?? "", { field: i, fieldState: s } = Re({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ I(
    Q,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: s.error,
      children: [
        /* @__PURE__ */ t(
          qt,
          {
            isRequired: a,
            id: e.name,
            "data-testid": e.name,
            validated: s.error ? H.error : H.default,
            isDisabled: e.isDisabled,
            ...r,
            ...i
          }
        ),
        e.helperText && /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(ze, { children: /* @__PURE__ */ t(Je, { children: e.helperText }) }) })
      ]
    }
  );
}, Ur = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: s,
  isDisabled: o,
  isFullWidth: d = !0,
  onSelect: c,
  ...h
}) => {
  const {
    control: u,
    formState: { errors: m }
  } = Ae(), [g, C] = R(!1), E = ce(i.rules?.required) === !0;
  return /* @__PURE__ */ t(
    Q,
    {
      id: e,
      name: n,
      label: r,
      isRequired: E,
      error: N(m, n),
      labelIcon: s,
      children: /* @__PURE__ */ t(
        oe,
        {
          ...i,
          name: n,
          control: u,
          render: ({ field: { onChange: v, value: f } }) => /* @__PURE__ */ t(
            xe,
            {
              ...h,
              variant: "default",
              onClick: () => C(!g),
              onOpenChange: () => C(!1),
              selected: re(a) ? a.filter(
                (b) => Array.isArray(f) ? f.includes(b.key) : f === b.key
              ).map((b) => b.value) : f,
              toggle: (b) => /* @__PURE__ */ t(
                pe,
                {
                  id: e || n,
                  ref: b,
                  onClick: () => C(!g),
                  isExpanded: g,
                  isFullWidth: d,
                  status: N(m, n) ? Qe.danger : void 0,
                  "aria-label": r,
                  isDisabled: o,
                  children: re(a) ? a.find(
                    (A) => A.key === (Array.isArray(f) ? f[0] : f)
                  )?.value : f
                }
              ),
              onSelect: (b, A) => {
                const w = A?.toString(), y = Array.isArray(f) ? [w] : w;
                c ? c(y, v) : v(y), C(!1);
              },
              isOpen: g,
              children: /* @__PURE__ */ t(Ee, { "data-testid": `select-${n}`, children: [...a, ...l].map((b) => /* @__PURE__ */ t(
                Ye,
                {
                  value: se(b),
                  description: !fe(b) && "description" in b ? b.description : void 0,
                  children: fe(b) ? b : b.value
                },
                se(b)
              )) })
            }
          )
        }
      )
    }
  );
}, ne = (e) => fe(e) ? e : e.value, $r = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: s,
  placeholderText: o,
  onFilter: d,
  variant: c,
  isFullWidth: h = !0,
  ...u
}) => {
  const {
    control: m,
    formState: { errors: g }
  } = Ae(), [C, E] = R(!1), [v, f] = R(""), [b, A] = R(0), [w, y] = R([]), T = Y(), P = ce(i.rules?.required) === !0, O = c === ue.typeaheadMulti, D = U(
    () => [
      ...a.filter(
        (p) => !l.map((k) => ne(k)).includes(ne(p))
      ),
      ...l
    ],
    [l, a]
  ), $ = D.filter(
    (p) => ne(p).toLowerCase().startsWith(v.toLowerCase())
  ), j = (p, k) => {
    k.value.includes(p) ? (k.onChange(k.value.filter((x) => x !== p)), re(a) && y(
      w.filter((x) => x.key !== p)
    )) : (k.onChange([...k.value, p]), re(D) && y([
      ...w,
      D.find((x) => x.key === p)
    ]));
  }, L = (p, k) => {
    const x = $[b];
    switch (E(!0), p.key) {
      case "Enter": {
        p.preventDefault(), f(O ? "" : ne(x)), j(se(x), k), E(!1), A(0);
        break;
      }
      case "Tab":
      case "Escape": {
        E(!1), k.onChange(void 0);
        break;
      }
      case "Backspace": {
        c === ue.typeahead && k.onChange("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        p.preventDefault();
        let M = 0;
        p.key === "ArrowUp" && (b === 0 ? M = a.length - 1 : M = b - 1), p.key === "ArrowDown" && (b === a.length - 1 ? M = 0 : M = b + 1), A(M);
        break;
      }
    }
  };
  return /* @__PURE__ */ t(
    Q,
    {
      id: e,
      name: n,
      label: r,
      isRequired: P,
      error: N(g, n),
      labelIcon: s,
      children: /* @__PURE__ */ t(
        oe,
        {
          ...i,
          name: n,
          control: m,
          render: ({ field: p }) => /* @__PURE__ */ t(
            xe,
            {
              ...u,
              onOpenChange: () => E(!1),
              selected: re(D) ? D.filter(
                (k) => Array.isArray(p.value) ? p.value.includes(k.key) : p.value === k.key
              ).map((k) => k.value) : p.value,
              shouldFocusFirstItemOnOpen: !1,
              toggle: (k) => /* @__PURE__ */ t(
                pe,
                {
                  ref: k,
                  id: e || n,
                  variant: "typeahead",
                  onClick: () => {
                    E(!C), T.current?.focus();
                  },
                  isExpanded: C,
                  isFullWidth: h,
                  status: N(g, n) ? Qe.danger : void 0,
                  children: /* @__PURE__ */ I(kt, { isPlain: !0, children: [
                    /* @__PURE__ */ t(
                      It,
                      {
                        placeholder: o,
                        value: c === ue.typeahead && p.value ? re(D) ? D.find(
                          (x) => x.key === (Array.isArray(p.value) ? p.value[0] : p.value)
                        )?.value : p.value : v,
                        onClick: () => E(!C),
                        onChange: (x, M) => {
                          f(M), d?.(M);
                        },
                        onKeyDown: (x) => L(x, p),
                        autoComplete: "off",
                        innerRef: T,
                        role: "combobox",
                        isExpanded: C,
                        "aria-controls": "select-typeahead-listbox",
                        children: c === ue.typeaheadMulti && Array.isArray(p.value) && /* @__PURE__ */ t(Xe, { "aria-label": "Current selections", children: p.value.map(
                          (x, M) => /* @__PURE__ */ t(
                            Ze,
                            {
                              onClick: (B) => {
                                B.stopPropagation(), p.onChange(
                                  p.value.filter(
                                    (Z) => Z !== se(x)
                                  )
                                );
                              },
                              children: re(D) ? [
                                ...D,
                                ...w
                              ].find((B) => x === B.key)?.value : ne(x)
                            },
                            M
                          )
                        ) })
                      }
                    ),
                    /* @__PURE__ */ t(wt, { children: (!!v || p.value) && /* @__PURE__ */ t(
                      _,
                      {
                        variant: "plain",
                        onClick: () => {
                          f(""), p.onChange(O ? [] : ""), T.current?.focus();
                        },
                        "aria-label": "Clear input value",
                        children: /* @__PURE__ */ t(Ft, { "aria-hidden": !0 })
                      }
                    ) })
                  ] })
                }
              ),
              onSelect: (k, x) => {
                k?.stopPropagation();
                const M = x?.toString();
                O && Array.isArray(p.value) ? (f(""), j(M || "", p)) : (p.onChange(Array.isArray(p.value) ? [M] : M), E(!1));
              },
              isOpen: C,
              children: /* @__PURE__ */ t(Ee, { children: $.map((k, x) => /* @__PURE__ */ t(
                Ye,
                {
                  value: se(k),
                  isFocused: b === x,
                  isActive: p.value.includes(ne(k)),
                  description: !fe(k) && "description" in k ? k.description : void 0,
                  children: ne(k)
                },
                se(k)
              )) })
            }
          )
        }
      )
    }
  );
};
var ue = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(ue || {});
const re = (e) => typeof e[0] != "string", fe = (e) => typeof e == "string", se = (e) => fe(e) ? e : e.key, Kr = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(Ur, { ...n }) : /* @__PURE__ */ t($r, { ...n, variant: e }), Ke = (e) => e && typeof e == "string" ? e.includes("${") : !1, He = (e) => e.substring(2, e.length - 1), ae = (e, n, r, a) => {
  const l = n || r, i = Ke(l) ? He(l) : l, s = a ? `${a}.${i}` : i;
  return e(s || "");
}, je = (e, n) => ae(e, n.displayName, n.name), Hr = ["username", "firstName", "lastName", "email"], Ut = (e) => e && Hr.includes(e), X = (e) => `${Ut(e) ? "" : "attributes."}${e?.replaceAll(
  ".",
  "🍺"
)}`, Wa = (e) => e.replaceAll(".", "🍺"), jr = (e) => e.replaceAll("🍺", ".");
function za(e, n, r) {
  (e.responseData.errors !== void 0 ? e.responseData.errors : [e.responseData]).forEach((a) => {
    const l = Object.assign(
      {},
      a.params?.map((i) => Ke(i) ? r(He(i)) : i)
    );
    n(X(a.field), {
      message: r(
        Ke(a.errorMessage) ? He(a.errorMessage) : a.errorMessage,
        {
          /* eslint-disable @typescript-eslint/no-misused-spread */
          ...l,
          defaultValue: a.errorMessage || a.field
        }
      ),
      type: "server"
    });
  });
}
function De({
  required: e
}) {
  return e;
}
function Ja(e) {
  if (typeof e != "object" || e === null || !("responseData" in e))
    return !1;
  const { responseData: n } = e;
  return ut(n) ? !0 : typeof n != "object" || n === null || !("errors" in n) || !Array.isArray(n.errors) ? !1 : n.errors.every(ut);
}
function ut(e) {
  return !(typeof e != "object" || e === null || !("field" in e) || typeof e.field != "string" || !("errorMessage" in e) || typeof e.errorMessage != "string");
}
const Ya = ({
  labelOn: e,
  stringify: n,
  defaultValue: r,
  labelIcon: a,
  ...l
}) => {
  const s = r ?? (n ? "false" : !1), { control: o } = Ae();
  return /* @__PURE__ */ t(
    Q,
    {
      hasNoPaddingTop: !0,
      name: l.name,
      isRequired: l.rules?.required === !0,
      label: l.label,
      labelIcon: a,
      children: /* @__PURE__ */ t(
        oe,
        {
          control: o,
          name: l.name,
          defaultValue: s,
          render: ({ field: { onChange: d, value: c } }) => /* @__PURE__ */ t(
            cn,
            {
              ...l,
              id: l.name,
              "data-testid": jr(l.name),
              label: e,
              "aria-label": l.label,
              isChecked: n ? c === "true" : c,
              onChange: (h, u) => {
                const m = n ? u.toString() : u;
                l.onChange?.(h, u), d(m);
              }
            }
          )
        }
      )
    }
  );
}, Qa = (e) => {
  const n = !!e.rules?.required, r = e.defaultValue ?? "", { field: a, fieldState: l } = Re({
    ...e,
    defaultValue: r
  });
  return /* @__PURE__ */ t(
    Q,
    {
      isRequired: n,
      label: e.label,
      labelIcon: e.labelIcon,
      name: e.name,
      error: l.error,
      children: /* @__PURE__ */ t(
        St,
        {
          isRequired: n,
          id: e.name,
          "data-testid": e.name,
          validated: l.error ? H.error : H.default,
          isDisabled: e.isDisabled,
          ...e,
          ...a
        }
      )
    }
  );
}, Xa = (e) => {
  const { labelIcon: n, helperText: r, ...a } = e, l = !!ce(e.rules?.required), i = e.defaultValue ?? "", { field: s, fieldState: o } = Re({
    ...e,
    defaultValue: i
  });
  return /* @__PURE__ */ I(
    Q,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: l,
      error: o.error,
      children: [
        /* @__PURE__ */ t(
          Te,
          {
            isRequired: l,
            id: e.name,
            "data-testid": e["data-testid"] || e.name,
            validated: o.error ? H.error : H.default,
            isDisabled: e.isDisabled,
            ...a,
            ...s
          }
        ),
        r && /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(ze, { children: /* @__PURE__ */ t(Je, { children: r }) }) })
      ]
    }
  );
}, Gr = St, Za = (e) => {
  const { labelIcon: n, ...r } = e, a = !!ce(e.rules?.required), l = e.defaultValue ?? "", { t: i } = q(), [s, o] = R(""), { field: d, fieldState: c } = Re({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ t(
    Q,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: c.error,
      children: /* @__PURE__ */ t(
        dn,
        {
          isRequired: a,
          "data-testid": e["data-testid"] || e.name,
          filename: s,
          browseButtonText: i("browse"),
          validated: c.error ? H.error : H.default,
          hideDefaultPreview: !0,
          isDisabled: e.isDisabled,
          type: "text",
          onFileInputChange: (h, u) => {
            d.onChange(u), o(u.name);
          },
          onClearClick: () => {
            d.onChange(null), o("");
          },
          ...r,
          ...d
        }
      )
    }
  );
}, el = ({ icon: e }) => {
  const n = Wr(e);
  return /* @__PURE__ */ t(_e, { size: "lg", children: /* @__PURE__ */ t(n, { alt: e }) });
};
function Wr(e) {
  switch (e) {
    case "github":
      return sr;
    case "facebook":
      return ir;
    case "gitlab":
      return lr;
    case "google":
      return ar;
    case "linkedin":
    case "linkedin-openid-connect":
      return rr;
    case "openshift-v4":
      return nr;
    case "stackoverflow":
      return tr;
    case "twitter":
      return er;
    case "microsoft":
      return Zn;
    case "bitbucket":
      return Xn;
    case "instagram":
      return Qn;
    case "paypal":
      return Yn;
    default:
      return Jn;
  }
}
const zr = "_title_180i0_2", Jr = {
  title: zr
}, $t = ({
  id: e,
  title: n,
  headingLevel: r = "h1",
  size: a = "xl",
  ...l
}) => /* @__PURE__ */ t(
  un,
  {
    headingLevel: r,
    size: a,
    className: Jr.title,
    id: e,
    tabIndex: 0,
    ...l,
    children: n
  }
), Yr = ({
  title: e,
  children: n,
  scrollId: r,
  className: a
}) => {
  const l = At();
  return /* @__PURE__ */ I(hn, { id: l, className: a, isFlat: !0, children: [
    /* @__PURE__ */ t(fn, { className: "kc-form-panel__header", children: /* @__PURE__ */ t(pn, { tabIndex: 0, children: /* @__PURE__ */ t($t, { id: r, title: e }) }) }),
    /* @__PURE__ */ t(mn, { className: "kc-form-panel__body", children: n })
  ] });
}, Qr = (e) => {
  const { title: n, children: r, scrollId: a, ...l } = e;
  return /* @__PURE__ */ t("section", { ...l, style: { marginTop: "var(--pf-v5-global--spacer--lg)" }, children: /* @__PURE__ */ I(W, { children: [
    /* @__PURE__ */ t($t, { id: a, title: n }),
    r
  ] }) });
}, Xr = "_panel_1cdve_1", Zr = "_sticky_1cdve_5", ht = {
  panel: Xr,
  sticky: Zr
}, ea = "kc-main-content-page-container", Be = (e) => e.replace(/\s+/g, "-"), ta = ({
  label: e,
  sections: n,
  borders: r = !1,
  ...a
}) => {
  const l = U(
    () => n.filter(({ isHidden: o }) => !o),
    [n]
  ), [i, s] = R(0);
  return le(() => {
    const o = document.getElementById(ea);
    if (!o) return;
    const d = 100, c = () => {
      const h = o.scrollTop + d;
      let u = 0;
      l.forEach(({ title: m }, g) => {
        const C = Be(m.toLowerCase()), E = document.getElementById(C);
        E && h >= E.offsetTop && (u = g);
      }), s(u);
    };
    return c(), o.addEventListener("scroll", c), () => o.removeEventListener("scroll", c);
  }, [l]), /* @__PURE__ */ I(gn, { hasGutter: !0, ...a, children: [
    /* @__PURE__ */ t(st, { md: 8, sm: 12, children: l.map(({ title: o, panel: d }) => {
      const c = Be(o.toLowerCase());
      return /* @__PURE__ */ t(Rt, { children: r ? /* @__PURE__ */ t(
        Yr,
        {
          scrollId: c,
          title: o,
          className: ht.panel,
          children: d
        }
      ) : /* @__PURE__ */ t(Qr, { scrollId: c, title: o, children: d }) }, o);
    }) }),
    /* @__PURE__ */ t(st, { md: 4, sm: 12, order: { default: "-1", md: "1" }, children: /* @__PURE__ */ t(yn, { className: ht.sticky, children: /* @__PURE__ */ t(vn, { isVertical: !0, label: e, children: l.map(({ title: o }, d) => {
      const c = Be(o.toLowerCase());
      return /* @__PURE__ */ t(
        bn,
        {
          isActive: i === d,
          onClick: () => {
            const h = document.getElementById(c);
            h && h.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          },
          "data-testid": `jump-link-${c}`,
          children: o
        },
        o
      );
    }) }) }) })
  ] });
}, na = (e, n, r) => (e.isValid || r) && (e.isDirty || n) && !e.isLoading && !e.isValidating && !e.isSubmitting, tl = ({
  formState: e,
  isDisabled: n = !1,
  allowInvalid: r = !1,
  allowNonDirty: a = !1,
  children: l,
  ...i
}) => /* @__PURE__ */ t(
  _,
  {
    variant: "primary",
    isDisabled: !na(e, a, r) || n,
    ...i,
    type: "submit",
    children: l
  }
), ra = (e) => {
  try {
    return new Intl.DisplayNames([e], { type: "language" }).of(e);
  } catch {
    return e;
  }
}, aa = ({
  t: e,
  form: n,
  supportedLocales: r,
  currentLocale: a
}) => {
  const l = U(
    () => r.map((i) => ({
      key: i,
      value: e(`locale_${i}`, ra(i) ?? i)
    })).sort((i, s) => i.value.localeCompare(s.value, a)),
    [r, a, e]
  );
  return l.length ? /* @__PURE__ */ t(fr, { ...n, children: /* @__PURE__ */ t(
    Kr,
    {
      "data-testid": "locale-select",
      name: "attributes.locale",
      label: e("selectALocale"),
      controller: { defaultValue: "" },
      options: [{ key: "", value: e("defaultLocale") }, ...l],
      variant: l.length >= 10 ? "typeahead" : "single"
    }
  ) }) : null;
}, me = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  children: l
}) => {
  const i = ae(
    e,
    r.annotations?.inputHelperTextBefore
  ), {
    formState: { errors: s }
  } = n, o = a?.(r), d = N(s, X(r.name));
  return /* @__PURE__ */ I(
    Ct,
    {
      label: je(e, r) || "",
      fieldId: r.name,
      isRequired: De(r),
      labelIcon: i ? /* @__PURE__ */ t(_t, { helpText: i, fieldLabelId: r.name }) : void 0,
      children: [
        o ? /* @__PURE__ */ I(Se, { children: [
          l,
          o
        ] }) : l,
        d && /* @__PURE__ */ t(
          Nt,
          {
            "data-testid": `${r.name}-helper`,
            message: d.message
          }
        )
      ]
    },
    r.name
  );
}, la = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  ...l
}) => /* @__PURE__ */ t(me, { t: e, form: n, attribute: r, renderer: a, children: /* @__PURE__ */ t(
  ia,
  {
    t: e,
    form: n,
    "aria-label": je(e, r),
    name: X(r.name),
    defaultValue: [r.defaultValue || ""],
    addButtonLabel: e("addMultivaluedLabel", {
      fieldLabel: je(e, r)
    }),
    isDisabled: r.readOnly,
    ...l
  }
) }), ia = ({
  t: e,
  name: n,
  inputType: r,
  form: a,
  addButtonLabel: l,
  isDisabled: i = !1,
  defaultValue: s,
  id: o,
  ...d
}) => {
  const { register: c, setValue: h, control: u } = a, m = pr({
    name: n,
    control: u,
    defaultValue: s || ""
  }), g = U(() => Array.isArray(m) && m.length !== 0 ? m : s || [""], [m]), C = (A) => {
    f([...g.slice(0, A), ...g.slice(A + 1)]);
  }, E = () => {
    f([...g, ""]);
  }, v = (A, w) => {
    f([...g.slice(0, A), w, ...g.slice(A + 1)]);
  }, f = (A) => {
    const w = A.flatMap((y) => y);
    h(n, w, {
      shouldDirty: !0
    });
  }, b = r.startsWith("html") ? r.substring(6) : "text";
  return le(() => {
    c(n);
  }, [c]), /* @__PURE__ */ t("div", { id: o, children: g.map((A, w) => /* @__PURE__ */ I(Rt, { children: [
    /* @__PURE__ */ I(Se, { children: [
      /* @__PURE__ */ t(qe, { isFill: !0, children: /* @__PURE__ */ t(
        Te,
        {
          "data-testid": n + w,
          onChange: (y, T) => v(w, T),
          name: `${n}.${w}.value`,
          value: A,
          isDisabled: i,
          type: b,
          ...d
        }
      ) }),
      /* @__PURE__ */ t(qe, { children: /* @__PURE__ */ t(
        _,
        {
          "data-testid": "remove" + w,
          variant: Ie.link,
          onClick: () => C(w),
          tabIndex: -1,
          "aria-label": e("remove"),
          isDisabled: g.length === 1 || i,
          children: /* @__PURE__ */ t(or, {})
        }
      ) })
    ] }),
    w === g.length - 1 && /* @__PURE__ */ I(
      _,
      {
        variant: Ie.link,
        onClick: E,
        tabIndex: -1,
        "aria-label": e("add"),
        "data-testid": "addValue",
        isDisabled: !A || i,
        children: [
          /* @__PURE__ */ t(Pt, {}),
          " ",
          e(l || "add")
        ]
      }
    )
  ] }, w)) });
}, ft = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = De(a), i = r.startsWith("multiselect"), s = i ? Cn : kn, o = a.validators?.options?.options || [], d = a.annotations?.inputOptionLabels || {}, c = a.annotations?.inputOptionLabelsI18nPrefix;
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    oe,
    {
      name: X(a.name),
      control: n.control,
      defaultValue: a.defaultValue,
      render: ({ field: h }) => /* @__PURE__ */ t(W, { children: o.map((u) => /* @__PURE__ */ t(
        s,
        {
          id: u,
          "data-testid": u,
          label: ae(e.t, d[u], u, c),
          value: u,
          isChecked: h.value?.includes(u),
          onChange: () => {
            i ? h.value?.includes(u) ? h.onChange(
              h.value?.filter((m) => m !== u)
            ) : h.onChange([...h.value || [], u]) : h.onChange([u]);
          },
          readOnly: a.readOnly,
          isRequired: l
        },
        u
      )) })
    }
  ) });
}, sa = ({
  toggleId: e,
  onToggle: n,
  onSelect: r,
  selections: a,
  isOpen: l,
  menuAppendTo: i,
  direction: s,
  width: o,
  maxHeight: d,
  toggleIcon: c,
  className: h,
  isDisabled: u,
  children: m,
  ...g
}) => {
  const [C, E] = R(!1), v = Y(), f = () => {
    E(!C), n(!C);
  }, b = () => i === "parent" && v.current?.parentElement || "inline", A = Dt.toArray(
    m
  );
  return /* @__PURE__ */ t(
    xe,
    {
      ref: v,
      maxMenuHeight: we(d),
      isScrollable: !0,
      popperProps: {
        appendTo: b(),
        direction: s,
        width: we(o)
      },
      ...g,
      onClick: f,
      onOpenChange: (w) => {
        w !== C && f();
      },
      selected: a,
      onSelect: (w, y) => {
        r?.(y || ""), f();
      },
      toggle: (w) => /* @__PURE__ */ t(
        pe,
        {
          id: e,
          ref: w,
          className: h,
          onClick: f,
          isExpanded: l,
          "aria-label": g["aria-label"],
          icon: c,
          isDisabled: u,
          isFullWidth: !0,
          children: A.find((y) => y.props.value === a)?.props.children || a || g["aria-label"]
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(Ee, { children: m })
    }
  );
}, oa = ({
  toggleId: e,
  onSelect: n,
  onToggle: r,
  onFilter: a,
  variant: l,
  validated: i,
  placeholderText: s,
  maxHeight: o,
  width: d,
  toggleIcon: c,
  direction: h,
  selections: u,
  typeAheadAriaLabel: m,
  chipGroupComponent: g,
  chipGroupProps: C,
  footer: E,
  isDisabled: v,
  children: f,
  ...b
}) => {
  const [A, w] = R(""), [y, T] = R(0), P = Y(), O = Dt.toArray(
    f
  ), D = a || !A ? O : O.filter((L) => {
    const { children: p, value: k } = L.props;
    return (typeof p == "string" ? p : String(k ?? "")).toLowerCase().includes(A.toLowerCase());
  }), $ = () => {
    r(!b.isOpen);
  }, j = (L) => {
    const p = D.at(y);
    switch (r(!0), L.key) {
      case "Enter": {
        if (L.preventDefault(), !p) break;
        l !== J.typeaheadMulti ? w(String(p.props.value)) : w(""), n?.(p.props.value), r(!1), T(0);
        break;
      }
      case "Escape": {
        r(!1);
        break;
      }
      case "Backspace": {
        l === J.typeahead && n?.("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        if (L.preventDefault(), D.length === 0) break;
        let k = 0;
        L.key === "ArrowUp" && (y === 0 ? k = D.length - 1 : k = y - 1), L.key === "ArrowDown" && (y === D.length - 1 ? k = 0 : k = y + 1), T(k);
        break;
      }
    }
  };
  return /* @__PURE__ */ I(
    xe,
    {
      ...b,
      onClick: $,
      onOpenChange: (L) => r(L),
      onSelect: (L, p) => {
        n?.(p || ""), a?.(""), w("");
      },
      maxMenuHeight: we(o),
      popperProps: { direction: h, width: we(d) },
      toggle: (L) => /* @__PURE__ */ t(
        pe,
        {
          ref: L,
          id: e,
          variant: "typeahead",
          onClick: () => r(!0),
          icon: c,
          isDisabled: v,
          isExpanded: b.isOpen,
          isFullWidth: !0,
          status: i === "error" ? Qe.danger : void 0,
          children: /* @__PURE__ */ I(kt, { isPlain: !0, children: [
            /* @__PURE__ */ t(
              It,
              {
                placeholder: s,
                value: l === J.typeahead && u ? u : A,
                onClick: $,
                onChange: (p, k) => {
                  w(k), T(0), a?.(k);
                },
                onKeyDown: (p) => j(p),
                autoComplete: "off",
                innerRef: P,
                role: "combobox",
                isExpanded: b.isOpen,
                "aria-controls": "select-typeahead-listbox",
                "aria-label": m,
                children: l === J.typeaheadMulti && Array.isArray(u) && (g || /* @__PURE__ */ t(Xe, { ...C, children: u.map((p, k) => /* @__PURE__ */ t(
                  Ze,
                  {
                    onClick: (x) => {
                      x.stopPropagation(), n?.(p);
                    },
                    children: p
                  },
                  k
                )) }))
              }
            ),
            /* @__PURE__ */ t(wt, { children: !!A && /* @__PURE__ */ t(
              _,
              {
                variant: "plain",
                onClick: () => {
                  n?.(""), w(""), a?.(""), P.current?.focus();
                },
                "aria-label": "Clear input value",
                children: /* @__PURE__ */ t(Ft, { "aria-hidden": !0 })
              }
            ) })
          ] })
        }
      ),
      children: [
        /* @__PURE__ */ t(Ee, { children: D }),
        E && /* @__PURE__ */ t(In, { children: E })
      ]
    }
  );
};
var J = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(J || {});
const we = (e) => typeof e == "number" ? e + "px" : e, ca = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(sa, { ...n }) : /* @__PURE__ */ t(oa, { ...n, variant: e }), pt = (e) => {
  const { t: n, form: r, inputType: a, attribute: l } = e, [i, s] = R(!1), [o, d] = R(""), c = a === "multiselect", h = (v, f) => {
    c ? f.value?.includes(v) ? f.onChange(f.value.filter((b) => b !== v)) : Array.isArray(f.value) ? f.onChange([...f.value, v]) : f.onChange([v]) : f.onChange(v === f.value ? "" : v);
  }, u = l.validators?.options?.options || [], m = l.annotations?.inputOptionLabels || {}, g = l.annotations?.inputOptionLabelsI18nPrefix, C = (v) => ae(e.t, m[v], v, g), E = (v) => u.filter(
    (f) => C(f).toLowerCase().includes(o.toLowerCase())
  ).map((f) => /* @__PURE__ */ t(
    Ye,
    {
      selected: Array.isArray(v) ? v.includes(f) : v === f,
      value: f,
      children: C(f)
    },
    f
  ));
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    oe,
    {
      name: X(l.name),
      defaultValue: l.defaultValue,
      control: r.control,
      render: ({ field: v }) => /* @__PURE__ */ t(
        ca,
        {
          toggleId: l.name,
          onToggle: (f) => s(f),
          onClear: () => h("", v),
          onSelect: (f) => {
            const b = f.toString();
            h(b, v), Array.isArray(v.value) || s(!1);
          },
          selections: c && Array.isArray(v.value) ? v.value.map((f) => C(f)) : C(v.value),
          variant: c ? J.typeaheadMulti : u.length >= 10 ? J.typeahead : J.single,
          "aria-label": n("selectOne"),
          isOpen: i,
          isDisabled: l.readOnly,
          onFilter: (f) => (d(f), E(v.value)),
          children: E(v.value)
        }
      )
    }
  ) });
}, da = (e) => {
  const { form: n, attribute: r } = e, a = De(r);
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    Gr,
    {
      id: r.name,
      "data-testid": r.name,
      ...n.register(X(r.name)),
      cols: r.annotations?.inputTypeCols,
      rows: r.annotations?.inputTypeRows,
      readOnly: r.readOnly,
      isRequired: a,
      defaultValue: r.defaultValue
    }
  ) });
}, K = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = De(a), i = r.startsWith("html") ? r.substring(6) : "text";
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    Te,
    {
      id: a.name,
      "data-testid": a.name,
      type: i,
      placeholder: a.readOnly ? "" : ae(
        e.t,
        a.annotations?.inputTypePlaceholder,
        "",
        a.annotations?.inputOptionLabelsI18nPrefix
      ),
      isDisabled: a.readOnly,
      isRequired: l,
      defaultValue: a.defaultValue,
      ...n.register(X(a.name))
    }
  ) });
}, Ge = {
  text: K,
  textarea: da,
  select: pt,
  "select-radiobuttons": ft,
  multiselect: pt,
  "multiselect-checkboxes": ft,
  "html5-email": K,
  "html5-tel": K,
  "html5-url": K,
  "html5-number": K,
  "html5-range": K,
  "html5-datetime-local": K,
  "html5-date": K,
  "html5-month": K,
  "html5-time": K,
  "multi-input": la
}, nl = ({
  t: e,
  form: n,
  userProfileMetadata: r,
  supportedLocales: a,
  currentLocale: l,
  hideReadOnly: i = !1,
  renderer: s
}) => {
  const o = U(() => {
    if (!r.attributes)
      return [];
    const d = i ? r.attributes.filter(({ readOnly: c }) => !c) : r.attributes;
    return [
      // Insert an empty group for attributes without a group.
      { name: void 0 },
      ...r.groups ?? []
    ].map((c) => ({
      group: c,
      attributes: d.filter(
        (h) => h.group === c.name
      )
    }));
  }, [
    i,
    r.groups,
    r.attributes
  ]);
  return o.length === 0 ? null : /* @__PURE__ */ t(
    ta,
    {
      label: e("jumpToSection"),
      sections: o.filter((d) => d.attributes.length > 0).map(({ group: d, attributes: c }) => ({
        title: ae(e, d.displayHeader, d.name) || e("general"),
        panel: /* @__PURE__ */ I("div", { className: "pf-v5-c-form", children: [
          d.displayDescription && /* @__PURE__ */ t(Ce, { className: "pf-v5-u-pb-lg", children: ae(e, d.displayDescription, "") }),
          c.map((h) => /* @__PURE__ */ t(
            ua,
            {
              t: e,
              form: n,
              supportedLocales: a,
              currentLocale: l,
              renderer: s,
              attribute: h
            },
            h.name
          ))
        ] })
      }))
    }
  );
}, ua = ({
  t: e,
  form: n,
  renderer: r,
  supportedLocales: a,
  currentLocale: l,
  attribute: i
}) => {
  const s = n.watch(
    X(i.name)
  ), o = U(() => fa(i), [i]), d = i.multivalued || ma(s) && i.annotations?.inputType === void 0 ? Ge["multi-input"] : Ge[o];
  return i.name === "locale" ? /* @__PURE__ */ t(
    aa,
    {
      form: n,
      supportedLocales: a,
      currentLocale: l,
      t: e,
      attribute: i
    }
  ) : /* @__PURE__ */ t(
    d,
    {
      t: e,
      form: n,
      inputType: o,
      attribute: i,
      renderer: r
    }
  );
}, ha = "text";
function fa(e) {
  if (Ut(e.name))
    return "text";
  const n = e.annotations?.inputType;
  return pa(n) ? n : ha;
}
const pa = (e) => typeof e == "string" && e in Ge, ma = (e) => Array.isArray(e) && e.length > 1, ga = ({
  className: e = "",
  border: n,
  size: r = "md"
}) => /* @__PURE__ */ I(
  "svg",
  {
    className: yr(
      ve.avatar,
      ve.modifiers[r],
      n === "light" && ve.modifiers.light,
      n === "dark" && ve.modifiers.dark,
      e
    ),
    enableBackground: "new 0 0 36 36",
    version: "1.1",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "circle",
        {
          style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
          cx: "18",
          cy: "18.5",
          r: "18"
        }
      ),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t(
        "filter",
        {
          id: "b",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          filterUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("feColorMatrix", { values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" })
        }
      ) }),
      /* @__PURE__ */ t(
        "mask",
        {
          id: "a",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("g", { style: { filter: 'url("#b")' }, children: /* @__PURE__ */ t(
            "circle",
            {
              style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
              cx: "18",
              cy: "18.5",
              r: "18"
            }
          ) })
        }
      ),
      /* @__PURE__ */ t("g", { style: { filter: 'url("#a")' }, children: /* @__PURE__ */ I("g", { transform: "translate(5.04 6.88)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m22.6 18.1c-1.1-1.4-2.3-2.2-3.5-2.6s-1.8-0.6-6.3-0.6-6.1 0.7-6.1 0.7 0 0 0 0c-1.2 0.4-2.4 1.2-3.4 2.6-2.3 2.8-3.2 12.3-3.2 14.8 0 3.2 0.4 12.3 0.6 15.4 0 0-0.4 5.5 4 5.5l-0.3-6.3-0.4-3.5 0.2-0.9c0.9 0.4 3.6 1.2 8.6 1.2 5.3 0 8-0.9 8.8-1.3l0.2 1-0.2 3.6-0.3 6.3c3 0.1 3.7-3 3.8-4.4s0.6-12.6 0.6-16.5c0.1-2.6-0.8-12.1-3.1-15z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m22.5 26c-0.1-2.1-1.5-2.8-4.8-2.8l2.2 9.6s1.8-1.7 3-1.8c0 0-0.4-4.6-0.4-5z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m12.7 13.2c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.8 6.4-6.4 6.4z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.08,
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#231F20"
            },
            d: "m9.4 6.8c0-3 2.1-5.5 4.9-6.3-0.5-0.1-1-0.2-1.6-0.2-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4c0.6 0 1.1-0.1 1.6-0.2-2.8-0.6-4.9-3.1-4.9-6.1z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m8.3 22.4c-2 0.4-2.9 1.4-3.1 3.5l-0.6 18.6s1.7 0.7 3.6 0.9l0.1-23z"
          }
        )
      ] }) })
    ]
  }
), mt = ({
  isKebab: e = !1,
  title: n,
  dropDownItems: r,
  ...a
}) => {
  const [l, i] = R(!1);
  return /* @__PURE__ */ t(
    wn,
    {
      ...a,
      popperProps: {
        position: "right"
      },
      onOpenChange: (s) => i(s),
      toggle: (s) => /* @__PURE__ */ t(
        pe,
        {
          "data-testid": `${a["data-testid"]}-toggle`,
          ref: s,
          onClick: () => i(!l),
          isExpanded: l,
          variant: e ? "plain" : "default",
          children: e ? /* @__PURE__ */ t(cr, {}) : n
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(Sn, { children: r })
    }
  );
};
function ya(e, n) {
  if (!e)
    return n("unknownUser");
  const r = e.given_name, a = e.family_name, l = e.preferred_username;
  return r && a ? n("fullName", { givenName: r, familyName: a }) : r || a || l || n("unknownUser");
}
const rl = ({
  keycloak: e,
  brand: { src: n, alt: r, className: a, ...l },
  avatar: i,
  features: {
    hasLogout: s = !0,
    hasManageAccount: o = !0,
    hasUsername: d = !0
  } = {},
  kebabDropdownItems: c,
  dropdownItems: h = [],
  toolbarItems: u,
  toolbar: m,
  ...g
}) => {
  const { t: C } = q(), E = [];
  o && E.push(
    /* @__PURE__ */ t(
      ot,
      {
        onClick: () => e.accountManagement(),
        children: C("manageAccount")
      },
      "manageAccount"
    )
  ), s && E.push(
    /* @__PURE__ */ t(ot, { onClick: () => e.logout(), children: C("signOut") }, "signOut")
  );
  const v = e.idTokenParsed?.picture;
  return /* @__PURE__ */ I(Tn, { ...g, children: [
    /* @__PURE__ */ t(xn, { children: /* @__PURE__ */ t(En, { variant: "plain", "aria-label": C("navigation"), children: /* @__PURE__ */ t(dr, {}) }) }),
    /* @__PURE__ */ t(An, { ...l, children: /* @__PURE__ */ t("img", { src: n, alt: r, className: a }) }),
    /* @__PURE__ */ I(Rn, { children: [
      m,
      /* @__PURE__ */ t(ke, { children: /* @__PURE__ */ I(Ue, { children: [
        u?.map((f, b) => /* @__PURE__ */ t(G, { align: { default: "alignRight" }, children: f }, b)),
        /* @__PURE__ */ t(
          G,
          {
            visibility: {
              default: "hidden",
              md: "visible"
            },
            children: /* @__PURE__ */ t(
              mt,
              {
                "data-testid": "options",
                dropDownItems: [...h, E],
                title: d ? ya(e.idTokenParsed, C) : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          G,
          {
            align: { default: "alignLeft" },
            visibility: {
              md: "hidden"
            },
            children: /* @__PURE__ */ t(
              mt,
              {
                "data-testid": "options-kebab",
                isKebab: !0,
                dropDownItems: [
                  ...c || h,
                  E
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          G,
          {
            variant: "overflow-menu",
            align: { default: "alignRight" },
            className: "pf-v5-u-m-0-on-lg",
            children: v || i?.src ? /* @__PURE__ */ t(Dn, { src: v, alt: C("avatar"), ...i }) : /* @__PURE__ */ t(ga, { ...i })
          }
        )
      ] }) })
    ] })
  ] });
}, Kt = et("ErrorBoundaryContext", void 0), Ht = () => tt(Kt);
class al extends $n {
  state = {};
  static getDerivedStateFromError = (n) => ({ error: n });
  showBoundary = (n) => {
    this.setState({ error: n });
  };
  render() {
    return /* @__PURE__ */ t(
      Kt.Provider,
      {
        value: { error: this.state.error, showBoundary: this.showBoundary },
        children: this.props.children
      }
    );
  }
}
const ll = ({ children: e, fallback: n }) => {
  const { error: r } = Ht();
  return r ? /* @__PURE__ */ t(n, { error: r }) : e;
};
function va(e, n, r) {
  const { showBoundary: a } = Ht();
  le(() => {
    const l = new AbortController(), { signal: i } = l;
    return e().then((s) => {
      i.aborted || n(s);
    }).catch((s) => {
      console.error(s), i.aborted || a(s);
    }), () => l.abort();
  }, r);
}
const ba = () => {
  const { t: e } = q();
  return /* @__PURE__ */ t(On, { children: /* @__PURE__ */ t(bt, { "aria-label": e("spinnerLoading") }) });
}, Ca = ({
  message: e,
  instructions: n,
  onPrimaryAction: r,
  hasIcon: a = !0,
  isSearchVariant: l,
  primaryActionText: i,
  secondaryActions: s,
  icon: o,
  isDisabled: d = !1,
  children: c
}) => /* @__PURE__ */ I(Fn, { "data-testid": "empty-state", variant: "lg", children: [
  a && l ? /* @__PURE__ */ t(ct, { icon: ur }) : a && /* @__PURE__ */ t(ct, { icon: o || Pt }),
  /* @__PURE__ */ t(Pn, { titleText: e, headingLevel: "h1" }),
  /* @__PURE__ */ t(Ln, { children: n }),
  /* @__PURE__ */ I(Vn, { children: [
    i && /* @__PURE__ */ t(
      _,
      {
        "data-testid": `${e.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: "primary",
        onClick: r,
        isDisabled: d,
        children: i
      }
    ),
    c,
    s && /* @__PURE__ */ t(Mn, { children: s.map((h) => /* @__PURE__ */ t(
      _,
      {
        "data-testid": `${h.text.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: h.type || Ie.secondary,
        onClick: h.onClick,
        isDisabled: d,
        children: h.text
      },
      h.text
    )) })
  ] })
] }), ka = ({
  toolbarItem: e,
  subToolbar: n,
  toolbarItemFooter: r,
  children: a,
  searchTypeComponent: l,
  inputGroupName: i,
  inputGroupPlaceholder: s,
  inputGroupOnEnter: o
}) => {
  const { t: d } = q(), [c, h] = R(""), u = (g) => {
    h(g.trim()), o?.(g.trim());
  }, m = (g) => {
    g.key === "Enter" && u(c);
  };
  return /* @__PURE__ */ I(W, { children: [
    /* @__PURE__ */ t(ke, { "data-testid": "table-toolbar", children: /* @__PURE__ */ I(Ue, { children: [
      i && /* @__PURE__ */ t(G, { children: /* @__PURE__ */ I(Se, { "data-testid": i, children: [
        l,
        s && /* @__PURE__ */ t(
          Bn,
          {
            "data-testid": "table-search-input",
            placeholder: s,
            "aria-label": d("search"),
            value: c,
            onChange: (g, C) => {
              h(C);
            },
            onSearch: () => u(c),
            onKeyDown: m,
            onClear: () => u("")
          }
        )
      ] }) }),
      e
    ] }) }),
    n && /* @__PURE__ */ t(ke, { children: /* @__PURE__ */ t(Ue, { children: n }) }),
    /* @__PURE__ */ t(Nn, {}),
    a,
    /* @__PURE__ */ t(ke, { children: r })
  ] });
}, gt = ({
  id: e,
  variant: n = "top",
  count: r,
  first: a,
  max: l,
  onNextClick: i,
  onPreviousClick: s,
  onPerPageSelect: o
}) => {
  const { t: d } = q(), c = Math.round(a / l);
  return /* @__PURE__ */ t(
    _n,
    {
      widgetId: e,
      titles: {
        paginationAriaLabel: `${d("pagination")} ${n} `
      },
      isCompact: !0,
      toggleTemplate: ({
        firstIndex: h,
        lastIndex: u
      }) => /* @__PURE__ */ I("b", { children: [
        h,
        " - ",
        u
      ] }),
      itemCount: r + c * l,
      page: c + 1,
      perPage: l,
      onNextClick: (h, u) => i((u - 1) * l),
      onPreviousClick: (h, u) => s((u - 1) * l),
      onPerPageSelect: (h, u, m) => o(m - 1, u),
      variant: n
    }
  );
}, Ia = ({
  count: e,
  searchTypeComponent: n,
  toolbarItem: r,
  subToolbar: a,
  children: l,
  inputGroupName: i,
  inputGroupPlaceholder: s,
  inputGroupOnEnter: o,
  ...d
}) => /* @__PURE__ */ t(
  ka,
  {
    searchTypeComponent: n,
    toolbarItem: /* @__PURE__ */ I(W, { children: [
      r,
      /* @__PURE__ */ t(G, { variant: "pagination", children: /* @__PURE__ */ t(gt, { count: e, ...d }) })
    ] }),
    subToolbar: a,
    toolbarItemFooter: e !== 0 ? /* @__PURE__ */ t(G, { variant: "pagination", children: /* @__PURE__ */ t(gt, { count: e, variant: "bottom", ...d }) }) : null,
    inputGroupName: i,
    inputGroupPlaceholder: s,
    inputGroupOnEnter: o,
    children: l
  }
), jt = (e) => !!e && e.title !== void 0, yt = ({
  row: e,
  index: n,
  actions: r,
  actionResolver: a
}) => {
  const l = r || a?.(e, {});
  return /* @__PURE__ */ I(W, { children: [
    e.cells.map((i, s) => /* @__PURE__ */ t(ie, { children: jt(i) ? i.title : i }, `cell-${s}`)),
    l && l.length > 0 && !e.disableActions && /* @__PURE__ */ t(ie, { isActionCell: !0, children: /* @__PURE__ */ t(Ir, { items: l, extraData: { rowIndex: n } }) })
  ] });
}, wa = ({ row: e }) => e.cells.map((n, r) => /* @__PURE__ */ t("div", { children: jt(n) ? n.title : n }, `cell-${r}`));
function Sa({
  columns: e,
  rows: n,
  actions: r,
  actionResolver: a,
  ariaLabelKey: l,
  selected: i,
  onSelect: s,
  onCollapse: o,
  canSelectAll: d,
  canSelect: c,
  isNotCompact: h,
  isRadio: u,
  ...m
}) {
  const { t: g } = q(), [C, E] = R(i || []), [v, f] = R([]), b = U(
    () => mr(
      C,
      n.map((y) => y.data),
      "id"
    ),
    [C, n]
  );
  le(() => {
    if (d) {
      const y = document.getElementsByName("check-all").item(0);
      if (y) {
        const T = y;
        T.indeterminate = b.length < n.length && b.length > 0;
      }
    }
  }, [C, d, n]);
  const A = (y) => {
    E(y), s?.(y);
  }, w = (y, T) => {
    if (u) {
      const P = T ? [n[y].data] : [];
      A(P);
    } else if (y === -1) {
      const P = b.map(
        (O) => N(O, "id")
      );
      A(
        T ? [...C, ...n.map((O) => O.data)] : C.filter(
          (O) => !P.includes(N(O, "id"))
        )
      );
    } else
      A(T ? [...C, n[y].data] : C.filter(
        (P) => N(P, "id") !== n[y].data.id
      ));
  };
  return /* @__PURE__ */ I(
    vr,
    {
      ...m,
      variant: h ? void 0 : br.compact,
      "aria-label": g(l),
      children: [
        /* @__PURE__ */ t(Cr, { children: /* @__PURE__ */ I(be, { children: [
          o && /* @__PURE__ */ t(Ve, { screenReaderText: g("expandRow") }),
          d && /* @__PURE__ */ t(
            Ve,
            {
              screenReaderText: g("selectAll"),
              select: u ? void 0 : {
                onSelect: (y, T) => {
                  w(-1, T);
                },
                isSelected: b.length === n.length
              }
            }
          ),
          e.map((y) => /* @__PURE__ */ t(
            Ve,
            {
              screenReaderText: g("expandRow"),
              className: y.transforms?.[0]().className,
              children: g(y.displayKey || y.name)
            },
            y.displayKey || y.name
          ))
        ] }) }),
        o ? n.map((y, T) => /* @__PURE__ */ t(dt, { children: T % 2 === 0 ? /* @__PURE__ */ I(be, { children: [
          /* @__PURE__ */ t(
            ie,
            {
              expand: n[T + 1].cells.length === 0 ? void 0 : {
                isExpanded: v[T] ?? !1,
                rowIndex: T,
                expandId: "expandable-row-",
                onToggle: (P, O, D) => {
                  o(D, O);
                  const $ = [...v];
                  $[T] = D, f($);
                }
              }
            }
          ),
          /* @__PURE__ */ t(
            yt,
            {
              row: y,
              index: T,
              actions: r,
              actionResolver: a
            }
          )
        ] }) : /* @__PURE__ */ I(be, { isExpanded: v[T - 1] ?? !1, children: [
          /* @__PURE__ */ t(ie, {}),
          /* @__PURE__ */ t(ie, { colSpan: e.length, children: /* @__PURE__ */ t(kr, { children: /* @__PURE__ */ t(wa, { row: y }) }) })
        ] }) }, T)) : /* @__PURE__ */ t(dt, { children: n.map((y, T) => /* @__PURE__ */ I(be, { isExpanded: v[T], children: [
          c && /* @__PURE__ */ t(
            ie,
            {
              select: {
                rowIndex: T,
                onSelect: (P, O, D) => {
                  w(D, O);
                },
                isSelected: !!C.find(
                  (P) => N(P, "id") === y.data.id
                ),
                variant: u ? "radio" : "checkbox",
                isDisabled: y.disableSelection
              }
            }
          ),
          /* @__PURE__ */ t(
            yt,
            {
              row: y,
              index: T,
              actions: r,
              actionResolver: a
            }
          )
        ] }, T)) })
      ]
    }
  );
}
function Ta({
  ariaLabelKey: e,
  searchPlaceholderKey: n,
  isPaginated: r = !1,
  onSelect: a,
  canSelectAll: l = !1,
  isNotCompact: i,
  isRadio: s,
  detailColumns: o,
  isRowDisabled: d,
  loader: c,
  columns: h,
  actions: u,
  actionResolver: m,
  searchTypeComponent: g,
  toolbarItem: C,
  subToolbar: E,
  emptyState: v,
  icon: f,
  isSearching: b = !1,
  ...A
}) {
  const { t: w } = q(), [y, T] = R([]), [P, O] = R(), [D, $] = R(), [j, L] = R(!1), [p, k] = Mt(
    localStorage,
    "pageSize",
    10
  ), [x, M] = R(p), [B, Z] = R(0), [z, Oe] = R(""), nt = Y(), [Fe, Gt] = R(0), Wt = Y(), rt = () => Gt(Fe + 1), zt = At(), at = (S, F) => S.map((V) => {
    if ("cellFormatters" in V) {
      const te = N(F, V.name);
      return V.cellFormatters?.reduce((de, ye) => ye(de), te);
    }
    if (V.cellRenderer) {
      const te = V.cellRenderer;
      return { title: /* @__PURE__ */ t(te, { ...F }) };
    }
    return N(F, V.name);
  }), lt = (S) => {
    const F = (V) => o?.[0]?.enabled?.(V);
    return S.map((V, te) => {
      const de = d ? d(V) : !1, ye = [
        {
          data: V,
          disableSelection: de,
          disableActions: de,
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- lodash get performs dynamic property access at runtime
          selected: !!y.find((Zt) => N(Zt, "id") === N(V, "id")),
          isOpen: F(V) ? !1 : void 0,
          cells: at(h, V)
        }
      ];
      return o && ye.push({
        parent: te * 2,
        cells: F(V) ? at(o, V) : []
      }), ye;
    }).flat();
  }, Pe = (S) => ["string", "number"].includes(typeof S) ? S.toString() : S instanceof Array ? S.map(Pe).join("") : typeof S == "object" ? Pe(
    Et(S.title) ? S.title.props : Object.values(S)
  ) : "", it = U(
    () => z === "" || r ? void 0 : lt(D || []).filter(
      (S) => S.cells.some(
        (F) => F && Pe(F).toLowerCase().includes(z.toLowerCase())
      )
    ).slice(B, B + x + 1),
    [z, B, x]
  );
  va(
    async () => {
      L(!0);
      const S = nt.current === "" && z !== "";
      return S && Z(0), nt.current = z, await (typeof c == "function" ? c : "loader" in c ? c.loader : async () => c)(S ? 0 : B, x + 1, z);
    },
    (S) => {
      Wt.current = Fe, r || ($(S), S.length > B ? S = S.slice(B, B + x + 1) : Z(0));
      const F = lt(S);
      O(F), L(!1);
    },
    [
      Fe,
      B,
      x,
      z,
      typeof c != "function" ? "signal" in c ? c.signal : c : void 0
    ]
  );
  const Jt = () => u && gr(u).map((S, F) => (delete S.onRowClick, S.onClick = async (V, te) => {
    await u[F].onRowClick(
      (it || P)[te].data
    ) && (r || Oe(""), rt());
  }, S)), Yt = (S, F) => {
    ee[F].isOpen = S, O([...ee]);
  }, ee = it || P, ge = !ee || ee.length === 0, Le = z !== "" || b, Qt = o ? x * 2 : x, Xt = o ? (ee?.length || 0) / 2 : ee?.length || 0;
  return /* @__PURE__ */ I(W, { children: [
    (!ge || Le) && /* @__PURE__ */ I(
      Ia,
      {
        id: zt,
        count: Xt,
        first: B,
        max: x,
        onNextClick: Z,
        onPreviousClick: Z,
        onPerPageSelect: (S, F) => {
          Z(S), M(F), k(F);
        },
        inputGroupName: n ? `${e}input` : void 0,
        inputGroupOnEnter: Oe,
        inputGroupPlaceholder: w(n || ""),
        searchTypeComponent: g,
        toolbarItem: /* @__PURE__ */ I(W, { children: [
          C,
          " ",
          /* @__PURE__ */ t(G, { variant: "separator" }),
          " ",
          /* @__PURE__ */ t(G, { children: /* @__PURE__ */ I(_, { variant: "link", onClick: rt, "data-testid": "refresh", children: [
            /* @__PURE__ */ t(hr, {}),
            " ",
            w("refresh")
          ] }) })
        ] }),
        subToolbar: E,
        children: [
          !j && !ge && /* @__PURE__ */ t(
            Sa,
            {
              ...A,
              canSelectAll: l,
              canSelect: !!a,
              selected: y,
              onSelect: (S) => {
                T(S), a?.(S);
              },
              onCollapse: o ? Yt : void 0,
              actions: Jt(),
              actionResolver: m,
              rows: ee.slice(0, Qt),
              columns: h,
              isNotCompact: i,
              isRadio: s,
              ariaLabelKey: e
            }
          ),
          !j && ge && Le && /* @__PURE__ */ t(
            Ca,
            {
              hasIcon: !0,
              icon: f,
              isSearchVariant: !0,
              message: w("noSearchResults"),
              instructions: w("noSearchResultsInstructions"),
              secondaryActions: b ? [] : [
                {
                  text: w("clearAllFilters"),
                  onClick: () => Oe(""),
                  type: Ie.link
                }
              ]
            }
          )
        ]
      }
    ),
    j && /* @__PURE__ */ t(ba, {}),
    !j && ge && !Le && v
  ] });
}
const xa = ({ link: e, organization: n }) => {
  const { t: r } = q();
  return /* @__PURE__ */ t(wr, { wrapModifier: "truncate", children: /* @__PURE__ */ I(e, { organization: n, children: [
    n.name,
    !n.enabled && /* @__PURE__ */ t(
      qn,
      {
        isRead: !0,
        className: "pf-v5-u-ml-sm",
        children: r("disabled")
      },
      `${n.id}-disabled`
    )
  ] }) });
}, Ea = (e) => {
  const { t: n } = q();
  return /* @__PURE__ */ t(
    Xe,
    {
      numChips: 2,
      expandedText: n("hide"),
      collapsedText: n("showRemaining"),
      children: e.domains?.map((r) => {
        const a = typeof r == "string" ? r : r.name;
        return /* @__PURE__ */ t(Ze, { isReadOnly: !0, children: a }, a);
      })
    }
  );
}, il = ({
  loader: e,
  toolbarItem: n,
  isPaginated: r = !1,
  isSearching: a = !1,
  searchPlaceholderKey: l,
  onSelect: i,
  onDelete: s,
  deleteLabel: o = "delete",
  link: d,
  children: c,
  actions: h
}) => {
  const { t: u } = q();
  return /* @__PURE__ */ t(
    Ta,
    {
      loader: e,
      isPaginated: r,
      isSearching: a,
      ariaLabelKey: "organizationList",
      searchPlaceholderKey: l,
      toolbarItem: n,
      onSelect: i,
      canSelectAll: i !== void 0,
      actions: [
        ...s ? [{ title: u(o), onRowClick: s }] : [],
        ...h ?? []
      ],
      columns: [
        {
          name: "name",
          displayKey: "name",
          cellRenderer: (m) => /* @__PURE__ */ t(xa, { link: d, organization: m })
        },
        {
          name: "domains",
          displayKey: "domains",
          cellRenderer: Ea
        },
        {
          name: "description",
          displayKey: "description"
        },
        {
          name: "membershipType",
          displayKey: "membershipType"
        }
      ],
      emptyState: c
    }
  );
};
export {
  Pr as AlertProvider,
  Ha as ContinueCancelModal,
  ll as ErrorBoundaryFallback,
  al as ErrorBoundaryProvider,
  Lr as ErrorPage,
  Za as FileUploadControl,
  Nt as FormErrorText,
  Yr as FormPanel,
  tl as FormSubmitButton,
  Nr as Help,
  _t as HelpItem,
  el as IconMapper,
  Ta as KeycloakDataTable,
  rl as KeycloakMasthead,
  $a as KeycloakProvider,
  ca as KeycloakSelect,
  ba as KeycloakSpinner,
  Gr as KeycloakTextArea,
  Ca as ListEmptyState,
  ja as NumberControl,
  il as OrganizationTable,
  Ia as PaginatingTableToolbar,
  Ga as PasswordControl,
  qt as PasswordInput,
  ta as ScrollForm,
  Kr as SelectControl,
  ue as SelectVariant,
  Ya as SwitchControl,
  ka as TableToolbar,
  Qa as TextAreaControl,
  Xa as TextControl,
  nl as UserProfileFields,
  Wa as beerify,
  et as createNamedContext,
  jr as debeerify,
  Ar as generateId,
  xr as getErrorDescription,
  Tr as getErrorMessage,
  Ka as getInjectedEnvironment,
  Er as getNetworkErrorDescription,
  Lt as getNetworkErrorMessage,
  Ke as isBundleKey,
  Rr as isDefined,
  Ja as isUserProfileError,
  ae as label,
  ea as mainPageContentId,
  za as setUserProfileServerError,
  qa as useAlerts,
  Ua as useEnvironment,
  Ht as useErrorBoundary,
  va as useFetch,
  Br as useHelp,
  tt as useRequiredContext,
  Dr as useSetTimeout,
  Mt as useStoredState
};
//# sourceMappingURL=keycloak-ui-shared.js.map
